import * as lvFlandersBarUi from '../dist/@lvflanders/bar-ui';

// global glue variable for externals
if (window['lvflanders'] == null) window['lvflanders'] = <any>{};
if (window['lvflanders'].bar == null) window['lvflanders'].bar = <any>{};

window['lvflanders'].bar.ui = lvFlandersBarUi;

export { lvFlandersBarUi };
